import { motion } from "framer-motion";
import "../styles/marketing.css";
import { 
  Search, 
  TrendingUp, 
  Target, 
  Mail,
  Share2,
  BarChart,
  MessageSquare
} from "lucide-react";

export default function MarketingSection() {
  const marketingServices = [
    {
      icon: <Search size={32} />,
      title: "SEO Optimisation",
      description: "Améliorez votre classement Google et augmentez votre visibilité organique.",
      stats: "+300% trafic"
    },
    {
      icon: <Target size={32} />,
      title: "Publicité Digital",
      description: "Campagnes ciblées sur Google Ads et réseaux sociaux pour des résultats rapides.",
      stats: "ROI 5:1"
    },
    {
      icon: <Mail size={32} />,
      title: "Email Marketing",
      description: "Stratégies d'emailing personnalisées pour fidéliser et convertir vos clients.",
      stats: "40% ouvertures"
    },
    {
      icon: <Share2 size={32} />,
      title: "Réseaux Sociaux",
      description: "Gestion complète de votre présence sur les plateformes sociales.",
      stats: "+500% engagement"
    },
    {
      icon: <BarChart size={32} />,
      title: "Analytics & Reporting",
      description: "Suivi des performances et rapports détaillés pour optimiser vos stratégies.",
      stats: "Data en temps réel"
    },
    {
      icon: <MessageSquare size={32} />,
      title: "Chatbots & IA",
      description: "Solutions automatisées pour engager vos visiteurs 24/7.",
      stats: "90% satisfaction"
    }
  ];

  return (
    <section className="marketing-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Marketing Digital & Stratégies</h2>
          <p className="section-subtitle">
            Augmentez votre visibilité et générez plus de leads avec nos solutions marketing
          </p>
        </div>
        
        <div className="marketing-grid">
          {marketingServices.map((service, index) => (
            <motion.div 
              key={index}
              className="marketing-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
            >
              <div className="marketing-icon">
                {service.icon}
              </div>
              <div className="marketing-content">
                <h3 className="marketing-title">{service.title}</h3>
                <p className="marketing-description">{service.description}</p>
                <div className="marketing-stats">
                  <TrendingUp size={16} />
                  <span>{service.stats}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        
        <div className="marketing-cta">
          <motion.div 
            className="cta-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="cta-content">
              <h3 className="cta-title">Stratégie Marketing Personnalisée</h3>
              <p className="cta-description">
                Obtenez une analyse gratuite de votre présence digitale et un plan d'action sur mesure.
              </p>
            </div>
            <a href="/contact" className="cta-button">
              Audit Gratuit
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}